<template>
  <footer class="bg-[#3b7cbd] text-white">
    <div class="px-4 py-3 flex items-center justify-between">
      <div>
        <p class="text-shadow-white text-sm">© 2026 Uganda Registration Services Bureau. All rights reserved.</p>
        <div class="flex items-center gap-4 mt-0.5">
          <a href="#" class="text-white text-xs hover:text-gray-300 transition">Privacy Policy</a>
          <a href="#" class="text-white text-xs hover:text-gray-300 transition">Terms of Service</a>
        </div>
      </div>
      <p class="text-white text-xs">Powered by GOVNET</p>
    </div>
  </footer>
</template>
<script setup lang="ts">
</script>